<template>
  <div>
    <div class="msg_box clearfloat">
      <div>
        <p>扫二维码关注公众号完成绑定</p>
        <img :src="ewm" alt="" />
        <p>{{ err }}</p>
        <p class="lan" @click="xin.goUrl('/applyVip')">跳过</p>
      </div>
    </div>
  </div>
</template>

<script>
import { chkPasswd } from "@/utlis/formrules";
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      ewm: "",
      timeId: -1,
      key: "",
      err: "",
    };
  },
  created() {
	if(this.$route.params.val){
		this.erwm(this.$route.params.key7);
	}else this.xin.goUrl('/login')
  },
  mounted() {},
  beforeDestroy() {
    clearTimeout(this.timeId);
  },
  methods: {
    ...mapMutations(["settoken"]),
    ...mapActions(["getUser"]),
    async erwm(key) {
      let msg2 = await this.api.Postewm({ key });
      if (msg2.code == -40002) this.$message.error(msg2.message);
      this.ewm = msg2.data.url;
      this.settime(msg2.data.key);
    },
    async settime(key) {
      //轮训
      this.timeId = setInterval(async () => {
        let { code, data, message } = await this.api.Postgonzhohao({ key });
        if (code == -40002) {
          this.$message({ message, type: "warning" });
          clearTimeout(this.timeId);
          this.err = message;
        } else if (code == 200) {
          this.$message({ message: "注册成功", type: "success" });
          clearTimeout(this.timeId);
          this.settoken(data.token);
          this.getUser();
          this.xin.goUrl("/applyVip");
        }
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.msg_box {
  margin-top: 50px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
	p {
	text-align: center;
	color: #868788;
	}
	.lan{
		color: #005599;
	}
  div {
  }
}
</style>
